import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

export const fetchEftAmount = (retailerId) => {
  const { url } = DepsService.rest.widgets.eft;
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.eft';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/eft-amount.api.js